module.exports = __webpack_public_path__ + "static/img/Taylor_Walker_mobile.7b7129a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Taylor_Walker_mobile.jpg
// module id = UQeB
// module chunks = 0